/**
 * Підсумок закриття зміни, який водій перевіряє перед остаточним «Закрити зміну».
 * Розрахунок той самий, що на бекенді (ShiftEntity::getMileage / getDurationMinutes):
 * пробіг = кінцевий − початковий одометр, тривалість — повні хвилини.
 */

export interface ClosingShift {
    vehicle?: { title?: string } | null
    startedAt?: string | null
    startOdometer?: number | null
}

export interface ClosingSummary {
    vehicle: string | null
    startOdometer: number | null
    endOdometer: number | null
    /** null — немає одного з одометрів */
    mileage: number | null
    startedAt: string | null
    endedAt: string
    /** null — невідомий час початку */
    durationMinutes: number | null
}

export const closingSummary = (shift: ClosingShift, endOdometer: number | null, endedAt: string): ClosingSummary => {
    const startOdometer = typeof shift.startOdometer === 'number' ? shift.startOdometer : null
    const started = shift.startedAt ? Date.parse(shift.startedAt) : Number.NaN
    const ended = Date.parse(endedAt)

    return {
        vehicle: shift.vehicle?.title ?? null,
        startOdometer,
        endOdometer,
        mileage: startOdometer !== null && endOdometer !== null ? endOdometer - startOdometer : null,
        startedAt: shift.startedAt ?? null,
        endedAt,
        durationMinutes:
            Number.isNaN(started) || Number.isNaN(ended) ? null : Math.max(0, Math.floor((ended - started) / 60000)),
    }
}
